<ng-container *ngIf="options$ | async as options">
  <ng-container *ngIf="options.maximumAllowedVotes !== 0 && options.candidates.length !== 0">
    <div class="d-flex flex-column justify-content-start align-items-center">
      <p class="title" [ngClass]="{'senate-title': type === 1, 'council-title': type === 2}">Alegeri
        <span>{{type === 1 ? 'Senat' : 'Consiliu'}}</span></p>
      <p class="votes-number">Poți
        vota {{options.maximumAllowedVotes}} {{options.maximumAllowedVotes === 1 ? 'candidat' : 'candidați'}}</p>
      <div class="students-container row w-100">
        <app-vote-card *ngFor="let candidate of options.candidates as senateCandidates; let odd = odd"
                       #card class="d-flex mb-4" [candidate]="candidate"
                       [class.col-6]="senateCandidates.length > 1"
                       [class.col-12]="senateCandidates.length === 1 || screenWidth <= 760"
                       [style.justifyContent]="senateCandidates.length === 1 ? 'center' : (odd ? 'flex-start' : 'flex-end')"
                       (voteValue)="emitVote($event, options.maximumAllowedVotes)"
                       [count]="count + 1" [allowedVotes]="options.maximumAllowedVotes"
        ></app-vote-card>
      </div>
    </div>
  </ng-container>
</ng-container>
<ng-container *ngIf="(options$ | async) === undefined">
  <div class="spinner-container">
    <mat-spinner></mat-spinner>
  </div>
</ng-container>
